// import { call, put, throttle } from 'redux-saga/effects';
import { TDispatch } from 'state';
import ErrorNotifier from 'app/scripts/services/error-notifier';
import { getSpotId } from 'app/scripts/services/app-state';
import { userParser } from '../parsers';
import { findUserByUsername, findUserByEmail } from '../../api/find-user';
import { ModerationSearchType } from '../types';
import { findUserSuggestionsSuccess, findUserSuggestionsFailure } from './index';

const findModerationUser = ({ search, type }) => {
  return async (dispatch: TDispatch) => {
    const spotId: string = getSpotId();
    const isUsername: boolean = type === ModerationSearchType.USERNAME;
    const isEmail: boolean = type === ModerationSearchType.EMAIL;
    const findUserApi = isUsername
      ? findUserByUsername
      : isEmail
      ? findUserByEmail
      : () => ({ suggestions: [] });

    try {
      const { suggestions } = await findUserApi(search);

      const userSuggestions = userParser(suggestions);

      dispatch(findUserSuggestionsSuccess({ suggestions: userSuggestions }));
    } catch (error) {
      console.error(error);
      ErrorNotifier.notifyError(`Failed to find user in moderation tab`, { search, type });
      dispatch(findUserSuggestionsFailure());
    }
  };
};

export default findModerationUser;
